import {
    Breadcrumbs,
    Heading,
    IconCalendar24,
    IconCheckmark24, IconChevronRight24,
    IconPurchase24,
    Link,
} from 'pac-ux-components';
import React, {useEffect, useState} from 'react';
import {useCookies} from 'react-cookie';
import Loading from '../Loading';
import Add24 from 'pac-ux-components/build/Icons/Navigation/Add24';
import Subtract24 from 'pac-ux-components/build/Icons/Navigation/Subtract24';
import { useParams } from 'react-router-dom';

function Transaction(props) {
    const apiRoot = process.env.REACT_APP_API_ROOT_URL;
    const [cookies] = useCookies(['idToken']);
    const apiHeaders = {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + cookies.idToken,
    };
    const { transactionId } = useParams();

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [transaction, setTransaction] = useState([]);
    const [journalExpanded, setJournalExpanded] = useState(null);

    useEffect(() => {
        getTransaction();
        // Empty dependency array means this effect runs once on mount
    }, []);

    const getTransaction = async () => {
        try {
            const response = await fetch(
                `${apiRoot}/backoffice/transactions/${transactionId}`,
                {headers: apiHeaders});
            if (!response.ok) {
                throw new Error('Failed to fetch transactions');
            }
            const transactionDetails = await response.json();
            console.log('transaction', transactionDetails);
            setTransaction(transactionDetails);
        } catch (err) {
            setError(err);
        } finally {
            setLoading(false);
        }
    };

    if (loading) return (<Loading/>);
    if (error) return (<p>Error: {error}</p>);

    return (
        <div>
            <div className="Transaction" style={{width: 1047}}>

                <Breadcrumbs
                    style={{height: 24}}
                >
                    <Link
                        style={{color: '#2264A0'}}
                        as="a" href="/transactions"
                        underline="none">Transactions</Link>
                </Breadcrumbs>

                <Heading color={'#10304C'}
                         style={{paddingTop: 32, paddingBottom: 16}}
                >Transaction</Heading>

            </div>
            <table width="1047px" className="Table" style={{
                fontWeight: 600,
                height: 48,
                fontSize: 16,
                fontFamily: 'Inter',
                border: 'thin solid #E0E0E0',
                padding: 8,
            }}>
                <tbody>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Idempotency Key
                    </td>
                    <td style={{paddingLeft: 16, border: 'thin solid #E0E0E0'}}>{transaction.idempotencyKey}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Checkout Session ID
                    </td>
                    <td style={{paddingLeft: 16, border: 'thin solid #E0E0E0'}}>{transaction.checkoutSessionId}</td>
                </tr>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Store
                    </td>
                    <td style={{paddingLeft: 16}} title={transaction.storeId}>{transaction.storeName}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Merchant Profile
                    </td>
                    <td style={{paddingLeft: 16}} title={transaction.merchantProfileId}>{transaction.merchantProfileName}</td>
                </tr>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Amount
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.amount.value}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Currency
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.amount.currency}</td>
                </tr>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Payment Method
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.paymentMethodName}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Payment Provider
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.paymentProviderName}</td>
                </tr>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Invoice ID
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.invoiceId}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Payment Reference
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.paymentReference}</td>
                </tr>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> PSP Reference
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.pspReference}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconPurchase24/> Error Code
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.errorCode}</td>
                </tr>
                </tbody>
            </table>

            <table width="1047px" className="Table" style={{
                fontWeight: 600,
                height: 48,
                fontSize: 16,
                fontFamily: 'Inter',
                border: 'thin solid #E0E0E0',
                padding: 8,
                marginTop: 32,
            }}>
                <tbody>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconCheckmark24/> Status
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{{
                        NEW: '🆕',
                        PROCESSING: '⏳',
                        AUTHORIZED: '🔐',
                        DECLINED: '❌',
                        CAPTURED: '✅',
                        FAILED: '⚠️',
                        CANCELLED: '🚫',
                        USER_CANCELLED: '🚫',
                        REFUNDED: '💸',
                        PARTIALLY_REFUNDED: '💸',
                        REFUND_SUCCESS: '💸',
                        REFUND_FAILED: '⚠️',
                        REFUND_INITIATED: '🆕'
                    }[transaction.status]} {transaction.status}</td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconCheckmark24/> Type
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>{transaction.type}</td>
                </tr>
                </tbody>
            </table>

            <table width="1047px" className="Table" style={{
                fontWeight: 600,
                height: 48,
                fontSize: 16,
                fontFamily: 'Inter',
                border: 'thin solid #E0E0E0',
                padding: 8,
                marginTop: 32,
            }}>
                <tbody>
                <tr style={{height: 48}}>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconCalendar24/> Created At
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>
                        {new Intl.DateTimeFormat('en-US', {
                            dateStyle: 'short',
                            timeStyle: 'long',
                        }).format(new Date(transaction.createdAt))}
                    </td>
                    <td width="25%" style={{
                        fontWeight: 'normal',
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}><IconCalendar24/> Last Updated
                    </td>
                    <td width="25%" style={{
                        paddingLeft: 16,
                        border: 'thin solid #E0E0E0',
                    }}>
                        {new Intl.DateTimeFormat('en-US', {
                            dateStyle: 'short',
                            timeStyle: 'long',
                        }).format(new Date(transaction.updatedAt))}
                    </td>
                </tr>
                </tbody>
            </table>

            <h2 style={{marginTop: 64}}>Transaction Journal</h2>

            {transaction.transactionJournals.map((journal) => (

                <table width="1047px" className="Table" style={{
                    fontWeight: 600,
                    height: 48,
                    fontSize: 16,
                    fontFamily: 'Inter',
                    border: 'thin solid #E0E0E0',
                    padding: 8,
                    marginTop: 32,
                }}>
                    <tbody>
                    <tr style={{height: 48}}>
                        <td width="50%" colspan={3} style={{paddingLeft: 16}}>
                            <IconChevronRight24/>
                            {new Intl.DateTimeFormat('en-US', {
                                dateStyle: 'short',
                                timeStyle: 'long',
                            }).format(new Date(journal.createdAt))}
                        </td>
                        <td style={{paddingRight: 16, cursor: 'pointer'}}
                            align="right"
                            onClick={() => {
                                if (journalExpanded === journal.id) {
                                    setJournalExpanded(null);
                                } else {
                                    setJournalExpanded(journal.id);
                                }
                            }}
                        >
                            {journalExpanded !== journal.id && (
                                <Add24/>
                            )}
                            {journalExpanded === journal.id && (
                                <Subtract24/>
                            )}

                        </td>
                    </tr>
                    <tr style={{height: 48}}>
                        <td width="50%" style={{
                            fontWeight: 'normal',
                            paddingLeft: 16,
                            border: 'thin solid #E0E0E0',
                        }}>
                            {journal.type}
                        </td>
                        <td width="20%" style={{
                            paddingLeft: 16,
                            border: 'thin solid #E0E0E0',
                        }}>
                            {journal.requestResponse}
                        </td>
                        <td width="20%" style={{
                            fontWeight: 'normal',
                            paddingLeft: 16,
                            border: 'thin solid #E0E0E0',
                        }}>Status
                        </td>
                        <td width="" style={{
                            paddingLeft: 16,
                            border: 'thin solid #E0E0E0',
                        }}>
                            {journal.statusCode}
                        </td>
                    </tr>
                    {journalExpanded === journal.id && (
                        <>
                            <tr style={{
                                height: 48,
                                border: 'thin solid #E0E0E0',
                            }}>
                                <td width="50%" style={{paddingLeft: 16}}>
                                    Headers
                                </td>
                            </tr>
                            <tr style={{
                                border: 'thin solid #E0E0E0',
                                height: 'auto',
                            }}>
                                <td colSpan={4} style={{
                                    padding: 16,
                                    whiteSpace: 'pre-wrap',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    backgroundColor: '#f8f9fa',
                                }}>
                                    {journal.headers ? JSON.stringify(journal.headers, null, 2) : 'No header content'}
                                </td>
                            </tr>
                            <tr style={{height: 48}}>
                                <td width="50%" style={{paddingLeft: 16}}>
                                    Body
                                </td>
                            </tr>
                            <tr style={{
                                border: 'thin solid #E0E0E0',
                                height: 'auto',
                            }}>
                                <td colSpan={4} style={{
                                    padding: 16,
                                    whiteSpace: 'pre-wrap',
                                    fontFamily: 'monospace',
                                    fontSize: '12px',
                                    backgroundColor: '#f8f9fa',
                                }}>
                                    {journal.body ? JSON.stringify(journal.body, null, 2) : 'No body content'}
                                </td>
                            </tr>
                        </>
                    )}
                    </tbody>
                </table>
            ))}
        </div>
    );
}

export default Transaction;
